import { Button } from '@/components/ui/button';
import { Hand, PlayCircle, HelpCircle } from 'lucide-react';

export const MODE_TUTORIAL_KEY = 'yr_mode_tutorial_seen';

export function ModeTutorial({ onClose }) {
  return (
    <div className="text-left rounded-2xl border border-[#00C8FF]/30 bg-[#00C8FF]/5 p-4" data-testid="mode-tutorial">
      <div className="font-display font-black text-xl">Choose How You Want to Train</div>
      <div className="mt-3">
        <div className="flex items-center gap-2 font-semibold text-sm"><PlayCircle className="w-4 h-4 text-[#00C8FF]" /> Continuous Mode — Let Your Coach Guide You</div>
        <p className="text-xs text-muted-foreground mt-1 leading-relaxed">Start once and follow your voice coach through the entire workout. Your coach counts your reps, guides your tempo, announces rest periods, and moves you to the next exercise automatically.</p>
        <p className="text-xs text-muted-foreground mt-1">You can pause whenever you need extra time.</p>
      </div>
      <div className="mt-3">
        <div className="flex items-center gap-2 font-semibold text-sm"><Hand className="w-4 h-4 text-[var(--c-green-ink)]" /> Manual Readiness Mode — You Control Each Start</div>
        <p className="text-xs text-muted-foreground mt-1 leading-relaxed">Your coach guides each exercise and rest period. When the next exercise is ready, tap “I’m ready” once you have reached the equipment and are prepared to begin.</p>
        <p className="text-xs text-muted-foreground mt-1">This mode is ideal when you need extra time to move between machines or set up your equipment.</p>
      </div>
      <p className="text-xs text-muted-foreground mt-3">You can change your preferred mode before starting a workout. Both modes follow the same training program.</p>
      <Button onClick={onClose} data-testid="mode-tutorial-close" className="mt-3 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] h-10 rounded-xl font-semibold">Got it</Button>
    </div>
  );
}

const MODES = [
  { id: 'continuous', icon: PlayCircle, title: 'Continuous', desc: 'Start once — your coach moves you through every exercise.' },
  { id: 'manual', icon: Hand, title: 'Manual readiness', desc: 'Tap “I’m ready” before each new exercise.' },
];

export function ModeChooser({ mode, setMode, onHelp }) {
  return (
    <div className="mt-5 text-left" data-testid="mode-chooser">
      <div className="flex items-center justify-between">
        <div className="label-mini">Progression</div>
        <button onClick={onHelp} data-testid="mode-help" className="text-xs text-[#00C8FF] inline-flex items-center gap-1"><HelpCircle className="w-3.5 h-3.5" /> How modes work</button>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-2">
        {MODES.map(m => (
          <button key={m.id} onClick={() => setMode(m.id)} data-testid={`mode-${m.id}`} aria-pressed={mode === m.id}
            className={`p-3 rounded-xl border text-left transition-colors ${mode === m.id ? 'border-[#00C8FF] bg-[#00C8FF]/10' : 'border-[var(--c-hair)]'}`}>
            <m.icon className={`w-4 h-4 ${mode === m.id ? 'text-[#00C8FF]' : 'text-muted-foreground'}`} />
            <div className="font-semibold text-sm mt-1">{m.title}</div>
            <div className="text-[11px] text-muted-foreground leading-snug mt-0.5">{m.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
